import { differenceInDays, isBefore } from 'date-fns';
import { FrequencyUnit, HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';
import { WeekDays } from 'shared/types/week-days';
import { getActualScheduleStartDate } from 'shared/utils/schedules';

import { getLastWeekDaysInTimeframe } from './get-last-week-days-in-timeframe';

export type Options = {
  startDate: Timestamp;
  endDate: Timestamp;
  weekStartsOn: WeekDays;
};

export const getScheduleTimeframeTarget = (
  schedule: HabitSchedule,
  { startDate, endDate, weekStartsOn }: Options,
) => {
  // get the start point for the schedule
  const scheduleStartDate = getActualScheduleStartDate(schedule);

  // check to see if the schedule is within range
  if (isBefore(endDate, scheduleStartDate)) {
    return 0;
  }

  if (schedule.frequency?.unit === FrequencyUnit.Week) {
    const dayDiff = differenceInDays(endDate, startDate);
    const amountOfLastWeekDays = getLastWeekDaysInTimeframe(
      startDate,
      endDate,
      weekStartsOn,
    );
    // only allow week counts when we want to now it for less than a quarter
    return dayDiff <= 42
      ? schedule.frequency.count * amountOfLastWeekDays.length
      : 0;
  }

  if (schedule.frequency?.unit === FrequencyUnit.Month) {
    const dayDiff = differenceInDays(endDate, startDate);
    // only allow counts for month targets when we want to now it for a month or less
    return dayDiff <= 31 ? schedule.frequency.count : 0;
  }

  // Year
  return schedule.frequency?.count ?? 0;
};
